var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('vx-table-simple',{attrs:{"columns":_vm.columns,"items":_vm.items},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Prizes ")]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }